import validator from 'validator'
import Library from '@/library'

const routes = []

routes.push({
  name: 'Route Mapper',
  path: '/route/mapper',
  component: require('@/views/RouteMapper/Mapper.vue').default
})

for (const type of Object.keys(Library.Enums.ObjectType)) {
  if (Library.Entities.hasCreate(type)) {
    const path = Library.Entities.getCreatePath(type)
    const name = `Create ${Library.Filters.toTitleCase(type)}`
    const component = Library.Entities.getCreateComponent(type)

    routes.push({
      path,
      name,
      component,
      props: Library.Entities.hasCreateComponent(type)
        ? true
        : (route) => ({
          type
        })
    })
  }

  if (Library.Entities.hasView(type)) {
    const path = Library.Entities.getViewPath(type)
    const name = `View ${Library.Filters.toTitleCase(type)}`
    const component = Library.Entities.getViewComponent(type)

    routes.push({
      path,
      name,
      component,
      props: (route) => ({
        type,
        id: typeof route.params.id === 'number' || !validator.isUUID(route.params.id)
          ? parseInt(route.params.id, 10)
          : route.params.id,
        load: route.query.load
      })
    })
  }
}

export default routes
